import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { ThemeProvider, useTheme } from './ThemeContext';
import Home from './components/Home';
import Articles from './components/Articles';
import Article1 from './components/Articles/Article1';
import Article2 from './components/Articles/Article2';
import Article3 from './components/Articles/Article3';
import Article4 from './components/Articles/Article4';
import Article5 from './components/Articles/Article5';
import PaperNotes from './components/PaperNotes';
import PaperReview1 from './components/Papers/Paper1';
import PaperReview2 from './components/Papers/Paper2';
import './App.css';

function AppContent() {
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    document.body.className = isDarkMode ? 'dark-mode' : 'light-mode';
  }, [isDarkMode]);

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <nav>
            <Link to="/"><button>Home</button></Link>
            {/* <Link to="/articles"><button>Articles</button></Link>
            <Link to="/paper-notes"><button>Paper Notes</button></Link>
            <button onClick={toggleTheme}>
              {isDarkMode ? 'Light Mode' : 'Dark Mode'}
            </button> */}
          </nav>
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/why-doom" element={<Article1 />} />
          <Route path="/articles/interpretability-race-conditions" element={<Article2 />} />
          <Route path="/articles/improving-interpretability-research" element={<Article3 />} />
          <Route path="/articles/alignment-from-interp" element={<Article4 />} />
          <Route path="/articles/probe-experiment-1" element={<Article5 />} />
	        <Route path="/paper-notes" element={<PaperNotes />} />
	        <Route path="/paper-notes/RESA" element={<PaperReview1/>} />
	        <Route path="/paper-notes/SPD" element={<PaperReview2/>} />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
